import * as e from "react";
import t from "../lib/IconBase.es.js";
import i from "../defs/GearSix.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: i }));
o.displayName = "GearSixIcon";
const s = o;
export {
  s as GearSix,
  o as GearSixIcon
};
